import { FileService } from '../../services/file.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ReportingService } from '../../services/reporting.service';
import { InvoiceReportModel } from '../../models/nce-orders-report';
import { Sort } from '@angular/material/sort';
import { NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { TablefilterMultiplePipe } from '../../shared/pipes/tablefilter-multiple.pipe';
import { CommonService } from '../../services';
import { NgProgressService } from '../../services/ngProgress.service';

declare var $: any;


@Component({
  selector: 'app-nce-orders-report',
  templateUrl: './nce-orders-report.component.html',
  styleUrls: ['./nce-orders-report.component.css']
})
export class NCEOrderReportComponent implements OnInit, OnDestroy {
  title = '';
  loadingFinished = false;
  loadContent = false;
  NCEOrders: any = [];
  sortedData: Array<InvoiceReportModel> = [];
  
  hasEmptyFilterResult: boolean = false;
  filterResultArr: any;
  //search
  searchField: string;

  //export excel
  url: string;

  //unsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();


  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private calendar: NgbCalendar,
    private reportingService: ReportingService,
    private commonService: CommonService,
    private fileService: FileService,
    private ngProgress: NgProgressService
  ) {
    this.title = 'NCE Orders Report';
  } 

  sortData(sort: Sort) {
    let data = this.NCEOrders.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'tenantName': return compare(a.tenantName.toLowerCase(), b.tenantName.toLowerCase(), isAsc);
        case 'tenantGuid': return compare(a.tenantGuid.toLowerCase(), b.tenantGuid.toLowerCase(), isAsc);
        case 'subscriptionGuid': return compare(a.subscriptionGuid.toLowerCase(), b.subscriptionGuid.toLowerCase(), isAsc);
        case 'subscriptionOfferName': return compare(a.subscriptionName.toLowerCase(), b.subscriptionName.toLowerCase(), isAsc);
        case 'dateCompleted': return compare(a.dateCompleted.toLowerCase(), b.dateCompleted.toLowerCase(), isAsc);
        case 'action': return compare(a.changeType.toLowerCase(), b.changeType.toLowerCase(), isAsc);
        case 'Qty': return compare(a.changeQty.toLowerCase(), b.changeQty.toLowerCase(), isAsc);
        case 'unitPrice': return compare(a.unitPrice.toLowerCase(), b.unitPrice.toLowerCase(), isAsc);
        case 'rrp': return compare(a.rrp.toLowerCase(), b.rrp.toLowerCase(), isAsc);
        case 'extPrice': return compare(a.extPrice.toLowerCase(), b.extPrice.toLowerCase(), isAsc);
        case 'extRrp': return compare(a.extRrp.toLowerCase(), b.extRrp.toLowerCase(), isAsc);
        case 'user': return compare(a.user.toLowerCase(), b.user.toLowerCase(), isAsc);
        default: return 0;
      }
    });
  }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(param => {
      this.ngProgress.start();
      this.getNCEOrdersReport();
    });
  }

  getNCEOrdersReport() {
    this.reportingService.getNCEOrdersReport().subscribe((value: InvoiceReportModel[]) => {
      this.NCEOrders = value;
      this.sortedData = this.NCEOrders.slice();
      //this.setUpViewModel(this.sortedData);
      this.loadContent = true;
    },
      (error: any) => {
        console.info(error);
        this.ngProgress.done();
        this.loadContent = true;
      });
  }
  setUpViewModel(data: any) {
    for (var i = 0; i < data.length; i++) {

      if (this.sortedData.length === 0 || this.sortedData[this.sortedData.length - 1].tenantGuid + this.sortedData[this.sortedData.length - 1].tenantName !==
        data[i].tenantGuid + data[i].tenantName) {
        this.sortedData.push({
          tenantName: data[i].tenantName,
          tenantGuid: data[i].tenantGuid,
          subscriptionGuid: data[i].subscriptionGuid,
          subscriptionName: data[i].subscriptionOfferName,
          dateAdded: data[i].dateCompleted,
          unitPrice: data[i].unitPrice,
          rrp: data[i].rrp,
          extPrice: data[i].ext_Price,
          extRrp: data[i].ext_RRP,
          user: data[i].user,
         
        });
      }
      /*  else {
         debugger;
         this.sortedData.push({
           tenantName: data[i].tenantName,
           tenantGuid: data[i].tenantGuid,
           subscriptionGuid: data[i].subscriptionGuid,
           subscriptionName: data[i].subscriptionOfferName,
           dateAdded: data[i].dateCompleted,
           unitPrice : data[i].unitPrice,
           rrp:data[i].rrp,
           extPrice:data[i].extPrice,
           extRrp:data[i].extRrp,
           user:data[i].user,  
        
         });
       } */

    }
  }
  downloadReport(): void {
    this.ngProgress.start();
    this.reportingService.GetNCEOrdersReportData()
      .subscribe((data: any) => {
        //const fileName = `DD_Backorders_${this.accountId}.xlsx`;
        const fileName = `DD_NCEOrders.xlsx`;
        this.fileService.saveAsExcelFile(data, fileName);
        this.ngProgress.done();
        this.commonService.implementToast('NCE Orders report downloaded successfully', 'Success');

      },
        (error: any) => {
          console.info(error);
          this.ngProgress.done();
        })

  }
  copyNCEOrdersReportLink(): void {
    this.reportingService.copyNCEOrdersReportLink().subscribe((res: string) => {
      if (res) {
        const downloadURL = window.location.origin + res;       
        this.copyToClipboard(downloadURL);
        this.commonService.implementToast("NCE Order report download link copied to clipboard successfully", "Success");
      }
    },
      (error: any) => {
        console.error(error);
        this.commonService.implementToast("Get Datafeeds CSV download url failed", "Error");
      });
  }

  copyToClipboard(item: any): void {
    let listener = (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', (item));
      e.preventDefault();
    };

    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);
  } 

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  close() {
    //$('.page-contents').animate({ scrollLeft: -$('#levelOne').width() }, 400);
    this.router.navigateByUrl('/reporting');
  }

  onChange() {    
    //this.filterResultArr = new TablefilterMultiplePipe().transform(this.sortedData, ['tenantGuid', 'tenantName', 'subscriptionGuid', 'subscriptionOfferName', 'dateCompleted', 'action', 'changeQuantity', 'unitPrice', 'rrp', 'ext_Price', 'ext_RRP', 'user'], this.searchField);
    this.filterResultArr = new TablefilterMultiplePipe().transform(this.sortedData, ['tenantGuid', 'tenantName','subscriptionOfferName','subscriptionGuid','dateCompleted'], this.searchField);
    
    if (this.filterResultArr.length === 0 && this.searchField !== '') {     
      this.hasEmptyFilterResult = true;
    } else {     
      this.hasEmptyFilterResult = false;
    }
  }

  filterReset() {
    this.searchField = "";
    this.hasEmptyFilterResult = false;
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

